import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@ferris/react/components/loader';

import LocaleRoute from './LocaleRoute';
import ExperimentUtil from '../../utils/ExperimentUtil';
import { fetchAuthUrlWithService } from '../../utils/AuthUrlUtil';
import { isAuthFlagDisabled } from '../../utils/ExperimentsUtil';
import { UserCtx } from '../../contexts/user';

export const AUTH_FLOW_TYPES = {
    VR: 'VRBO',
    EPC_USER: 'EPC_USER'
};

const redirectFunction = (vrboOwnerAuthUrl) => {
    if (typeof window === 'object') {
        // TODO: Update me to reference pageflow instead of using hardcoded value
        const authUrl = fetchAuthUrlWithService(vrboOwnerAuthUrl, window.location.pathname);
        window.location.assign(`${authUrl}&screen=login&treatment=2fa`);
    }
};

const epcRedirectFunction = () => {
    if (typeof window === 'object') {
        let redirectUrl = `/Account/Logon?returnUrl=${encodeURIComponent(window.location.href)}`;
        if (window.location.host.includes('local')) {
            redirectUrl = `https://www.expediapartnercentral.com.integration.sb.karmalab.net${redirectUrl}`;
        } else {
            redirectUrl = `${window.location.protocol}//${(window.location.hostname).replace('apps', 'www')}${redirectUrl}`;
        }
        window.location.assign(redirectUrl);
    }
};

const authorized = ({
    protectedType,
    hasAdvertiserForSite
}) => {
    // default to owner.
    const pt = protectedType || 'owner';

    if (pt === 'owner' && !hasAdvertiserForSite) {
        return false; // They are effectively a traveler in this case
    }
    // in all other cases we are authorized, because we are logged in as an owner.
    return true;
};

const ProtectedRoute = ({ children, ...props }) => {
    const { experiments, authFlow } = props;
    const experimentUtil = new ExperimentUtil(experiments);
    const isAuthDisabled = isAuthFlagDisabled(experimentUtil);

    if (authFlow === AUTH_FLOW_TYPES.VR) {
        if (!isAuthDisabled && !authorized(props)) {
            return (
                <LocaleRoute {...props} render={(redirectFunction(props.vrboOwnerAuthUrl))} />
            );
        }
        return (
            <LocaleRoute {...props}>
                {children}
            </LocaleRoute>
        );
    }
    const {
        getEpcUserId,
        epcUserId,
        hasBeenInitialized
    } = useContext(UserCtx);
    const retrieveEpcUserId = async () => {
        await getEpcUserId();
    };
    useEffect(() => {
        retrieveEpcUserId();
    }, []);

    if (!hasBeenInitialized) {
        return (
            <Loader
                slide
                size="normal"
                visible
                title=""
            />
        );
    }

    // const epcProtection = async () => {
    if (hasBeenInitialized && !epcUserId && !isAuthDisabled) {
        // return (<>redirect</>);
        return (
            <LocaleRoute {...props} render={(epcRedirectFunction())} />
        );
    }
    return (
        <LocaleRoute {...props}>
            {children}
        </LocaleRoute>
    );
};

ProtectedRoute.propTypes = {
    children: PropTypes.element.isRequired,
    vrboOwnerAuthUrl: PropTypes.string.isRequired,
    isLoggedIn: PropTypes.bool,
    locale: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    experiments: PropTypes.arrayOf(PropTypes.object).isRequired,
    authFlow: PropTypes.string
};

ProtectedRoute.defaultProps = {
    isLoggedIn: false,
    locale: 'en_US',
    authFlow: AUTH_FLOW_TYPES.VR
};

export default ProtectedRoute;
